import { observable, action, computed } from 'mobx';
import { ReqInputMsg, Addition, callCmd } from 'lib/reqInputMsg';
import moment from 'moment';
import { notification } from 'antd';

export default class SettleStore {
  constructor(root) {
    this.root = root;
  }

  //----------------------------------
  /* Mainstore에서 세션만료 처리하기위해 */
  @observable
  _commonStoreInfo = null;

  @computed
  get commonStoreInfo() {
    return this._commonStoreInfo;
  }

  @action
  setCommonStoreInfo = (storeInfo) => {
    this._commonStoreInfo = storeInfo;
  };

  //----------------------------------
  /* 검색조건 */
  @observable 
  _valCondition = {
    strDate: moment().subtract(1, 'month').format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
    orGdNm: '',
    ceCd: '',
    ceBranchCd: '',

    pageIdx: 1,
    recordCountPerPage: 10
  };

  @computed
  get valCondition() {
    return this._valCondition;
  }

  @action
  onChangValue = (dataNm, dataVal) => {
    this._valCondition = {
      ...this._valCondition,
      [dataNm]: dataVal
    };
  };

  //----------------------------------
  @observable 
  _settleList = [];

  @computed
  get settleList() {
    return this._settleList;
  }

  @observable
  _pageInfo = null;

  @computed
  get pageInfo() {
    return this._pageInfo;
  }

  @observable 
  _totalPrice = "";

  @computed
  get totalPrice() {
    return this._totalPrice;
  }
  //----------------------------------
  @action
  onClear = () => {
    this._settleList = [];
    this._pageInfo = null;
    this._totalPrice = "";

    this._valCondition = {
      ...this._valCondition,
      strDate: moment().subtract(1, 'month').format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
      orGdNm: '',
      ceCd: '',
      ceBranchCd: '',

      pageIdx: 1,
      recordCountPerPage: 10
    };
  };
  //-----------------------------------
  //  정산 리스트
  //-----------------------------------
  @action
  disSettleList = async (pageIdx, recordCountPerPage) => {
    if (pageIdx !== undefined && pageIdx !== null && this._valCondition.pageIdx !== pageIdx) {
      this._valCondition.pageIdx = pageIdx;
    }
    if (recordCountPerPage !== undefined && recordCountPerPage !== null && this._valCondition.recordCountPerPage !== recordCountPerPage) {
      this._valCondition.recordCountPerPage = recordCountPerPage;
    }

    let addition = new Addition();

    addition.setCmdName('DIS-SETTLE-LIST');
    addition.setPageYn('Y');
    addition.setPageIndex(this._valCondition.pageIdx);
    addition.setRecordCountPerPage(this._valCondition.recordCountPerPage);

    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);

    reqInputMsg.addParam({paraName: 'strDate', paraValue: this._valCondition.strDate});
    reqInputMsg.addParam({paraName: 'endDate', paraValue: this._valCondition.endDate});
    reqInputMsg.addParam({paraName: 'orGdNm', paraValue: this._valCondition.orGdNm});
    reqInputMsg.addParam({paraName: 'ceCd', paraValue: this._valCondition.ceCd});
    reqInputMsg.addParam({paraName: 'ceBranchCd', paraValue: this._valCondition.ceBranchCd});
    
    return await callCmd(reqInputMsg, 'order')
      .then((res) => {
        if (res.error.code === '0000') {
          // notification.success({placement: 'bottomLeft', message:`조회가 성공하였습니다.`, duration: 2});
          this._settleList = res.result;
          this._pageInfo = res.addition;
          this.disSettlePrice();
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.error({placement: 'bottomLeft', message:`리스트를 불러오는데 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
          this._settleList = [];
          this._pageInfo = null;
          this._totalPrice = "";
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`조회가 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        this._settleList = [];
        this._pageInfo = null;
        this._totalPrice = "";
        console.log('error', error);
      });
  };

  @action
  disSettlePrice = async () => {
    let addition = new Addition();
    addition.setCmdName('DIS-SETTLE-PRICE');

    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.addParam({paraName: 'strDate', paraValue: this._valCondition.strDate});
    reqInputMsg.addParam({paraName: 'endDate', paraValue: this._valCondition.endDate});
    reqInputMsg.addParam({paraName: 'orGdNm', paraValue: this._valCondition.orGdNm});
    reqInputMsg.addParam({paraName: 'ceCd', paraValue: this._valCondition.ceCd});
    reqInputMsg.addParam({paraName: 'ceBranchCd', paraValue: this._valCondition.ceBranchCd});

    return await callCmd(reqInputMsg, 'order')
      .then((res) => {
        if (res.error.code === '0000') {
          if (res.result.length > 0 && res.result[0].totalPrice !== undefined && res.result[0].totalPrice !== null) {
            this._totalPrice = res.result[0].totalPrice;
          } else {
            this._totalPrice = "";
          }
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.error({placement: 'bottomLeft', message:`리스트를 불러오는데 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
          this._totalPrice = "";
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`조회가 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        this._totalPrice = "";
        console.log('error', error);
      });
  };
}
  
